import {
    Box,
    Button,
    TextField,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

function EinladenDialog({ open, onClose, searchQuery, onSearchQuery, onSearch, searching, searchResults, onInvite }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Mitglied einladen</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', gap: 1, mb: 2, mt: 1 }}>
                    <TextField
                        fullWidth
                        placeholder="Name oder E-Mail suchen..."
                        value={searchQuery}
                        onChange={(e) => onSearchQuery(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && onSearch()}
                    />
                    <Button
                        variant="contained"
                        onClick={onSearch}
                        disabled={searching || !searchQuery.trim()}
                    >
                        <SearchIcon />
                    </Button>
                </Box>

                {searchResults.length > 0 && (
                    <List>
                        {searchResults.map((user) => (
                            <ListItem
                                key={user.id}
                                secondaryAction={
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => onInvite(user.id)}
                                    >
                                        Einladen
                                    </Button>
                                }
                            >
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: 'secondary.main' }}>
                                        {user.vname.charAt(0)}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={`${user.vname} ${user.nname}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                )}

                {searchQuery && searchResults.length === 0 && !searching && (
                    <Typography color="text.secondary" align="center" sx={{ py: 2 }}>
                        Keine Nutzer gefunden
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Schließen</Button>
            </DialogActions>
        </Dialog>
    );
}

export default EinladenDialog;
